// extracted by mini-css-extract-plugin
module.exports = {"BooksOutlineButton":"BooksOutlineButton_BooksOutlineButton__IgV5S","isSmall":"BooksOutlineButton_isSmall__OaJfZ"};